module.exports = __webpack_public_path__ + "static/media/deck-4-left.772c51f8.png";